import { observer } from 'mobx-react';
import React from 'react';
import { localeStore } from '~/mobx/localesStore';
import T360LastSyncDate from '~/view/screens/SettingsScreen/screens/Integrations/Integrations/components/T360LastSyncDate/T360LastSyncDate';
import { TBooleanInNumber } from '~/types/main';
import { modalStore } from '~/mobx/modalStore';

interface IProps {
  last_sync_successful?: TBooleanInNumber;
  last_sync_date?: Date;
  is_active_sync?: TBooleanInNumber;
  last_sync_error?: any;
}

const T360LastSyncInfo: React.FC<IProps> = observer((props: IProps) => {
  const openLastSyncErrorModal = () => {
    modalStore.openT360SyncErrorsModal({
      syncErrors: props.last_sync_error,
    });
  };

  return (
    <>
      {props.last_sync_successful && props.last_sync_date ? <T360LastSyncDate lastSyncDate={props.last_sync_date} /> : null}
      {!props.last_sync_successful && !props.is_active_sync ? (
        <div className="t360-integration-settings-form__sync_result_tip error mt-5">
          {localeStore.t('t2_foodics_sync_error') + '. '}
          {props.last_sync_error ? (
            <span onClick={openLastSyncErrorModal} className="t360-integration-settings-form__sync_result_tip error_details">
              {localeStore.t('details')}
            </span>
          ) : null}
        </div>
      ) : null}
    </>
  );
});

export default T360LastSyncInfo;
